import React, { useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import * as XLSX from "xlsx";

const EstimateUploadModal = ({ show, onHide, disabled = false, onUploadComplete }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState(false);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleUpload = () => {
    if (!selectedFile) {
      alert("Please select a file to upload.");
      return;
    }

    setUploadStatus(true);

    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, {
        defval: "",
        raw: false,
      });

      if (typeof onUploadComplete === "function") {
        try {
          // ✅ wait for enrichment to finish
          await onUploadComplete({ jsonData, file: selectedFile });
          onHide(); // close only after enrichment
        } catch (err) {
          console.error("Upload failed:", err);
        }
      }

      setUploadStatus(false);
    };

    reader.readAsArrayBuffer(selectedFile);
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Upload Excel File</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {uploadStatus ? (
          <div className="d-flex justify-content-center align-items-center p-4">
            <Spinner animation="border" role="status" />
            <span className="ms-2">Processing file...</span>
          </div>
        ) : (
          <input
            className="form-control"
            type="file"
            accept=".csv, .xls, .xlsx"
            onChange={handleFileChange}
            disabled={uploadStatus || disabled}
          />
        )}
      </Modal.Body>

      <Modal.Footer>
        <button
          className="btn btn-secondary"
          onClick={onHide}
          disabled={uploadStatus}
        >
          Cancel
        </button>
        <button
          className="btn btn-primary"
          onClick={handleUpload}
          disabled={uploadStatus || disabled}
        >
          {uploadStatus ? <Spinner animation="border" size="sm" /> : "Upload"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default EstimateUploadModal;
 